class FormWithPhone extends HTMLElement {
  constructor() {
    super();

    this.addSubmitListener();

    this.addEventListener('input', function (e) {
      let input = e.target.value.replace(/\D/g, '');
      let formattedInput = '+1 (';
  
      if (input.length > 1) formattedInput += input.substring(1, 4);
  
      if (input.length >= 2) {
        formattedInput += ')';
      } else {
        formattedInput += '   )';
      }

      if (input.length >= 5) formattedInput += ' ' + input.substring(4, 7);

      if (input.length >= 8) formattedInput += ' - ' + input.substring(7, 11);

      e.target.value = formattedInput.substring(0, 19);
    });
  }

  addSubmitListener() {
    const FormWithPhoneEl = this.querySelector('#SubscribeWithPhone-Form');

    if (FormWithPhoneEl) {
      FormWithPhoneEl.addEventListener('submit', this.onFormSubmit);
    }
  }
  
  onFormSubmit(e) {
    e.preventDefault();

    console.log("check submitt")
    
    const successMessageEl = this.querySelector('.newsletter-with-phone__form--success');
    const errorMessageEl = this.querySelector('.newsletter-with-phone__form--error');
    const phoneValue = e.currentTarget.querySelector('input')?.value.trim();

    console.log(phoneValue);
    if (!phoneValue || phoneValue == "+1 (   )") return;

    const requestBody = {
      phone: phoneValue,
    };
  
    fetch('https://app.arcadian.ai/api/workspace-manager/workspace/anonymous-invite', {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json', 
      },
      body: JSON.stringify(requestBody),
    }).then(response => {
        if (!response.ok) {
          const error = new Error('Network response is not ok', { statusCode: 404 });
          error.code = "error_from_response";
          throw error;
        }
        return response.json();
      }).then(data => {
        if (successMessageEl) successMessageEl.classList.add('is-visible');
        if (errorMessageEl) errorMessageEl.classList.remove('is-visible');
      })
      .catch(error => {
        console.error('Error:', error);

        if (error.code === 'error_from_response') {
          if (successMessageEl) successMessageEl.classList.remove('is-visible');
          if (errorMessageEl) errorMessageEl.classList.add('is-visible');
        } else {
          if (successMessageEl) successMessageEl.classList.add('is-visible');
          if (errorMessageEl) errorMessageEl.classList.remove('is-visible');
        }
      });
  }
}

customElements.define('form-with-phone', FormWithPhone);
